/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import PrimaryTable from "../../../../Shared/components/PrimaryTable";
import { LinkProductsListHead } from "../../../../../config/constant";
import { TableCell, TableRow, Button, TextField, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Switch } from "@mui/material";
import customStyles from "../../../../../assets/styles/customStyles";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import { NavLink } from "react-router-dom";
import { Row, Col, Image, Space, Upload } from "antd";
import { LinkProductTable } from "./LinkProductTable";
import { Tooltip, IconButton, Typography, Box } from "@mui/material";
import infoMarkIcon from "../../../../../assets/images/icon_actions/infoMark.svg";
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import gstActions from "../../../../Admin/Setup/redux/actions";
import unitActions from "../../../../Product/Setup/redux/actions";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import { emptyValidation } from "../../../../../helpers/validation";
import actions from "../../redux/actions";
import crudActions from "../../../../CRUD/redux/actions";
import DeleteModal from "../../../../Shared/components/DeleteModal";
import ImportIcon from "../../../../../assets/images/icon_actions/Import.svg";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { SelectedIcon, UnSelectedIcon } from "../../../../Shared/components/Icons/selectedIcon";

export const ListTable = (props) => {
    const { productGstdetails, hsnDetails } = useSelector(state => state.adminSetupReducer);
    // const { catalogueDetails, productDetails, productLoader } = useSelector(state => state.younoteAdminProductReducer);
    const { catalogueDetails } = useSelector(state => state.younoteAdminProductReducer);
    const { unitMesurementdetails } = useSelector(state => state.productSetupReducer);
    //const { editDetails, editError, editLoader } = useSelector(state => state.crudReducer);
    const { editLoader } = useSelector(state => state.crudReducer);

    const classes = customStyles();
    const [visible, setVisible] = useState(false);
    const { details, categoryDetails, handleLoadingApi, categoryId } = props;
    const [useMrp, setUseMrp] = useState(false);
    const [view, setView] = useState(false);
    const [form, setForm] = useState({});
    const [error, setError] = useState({});
    const [productId, setProductId] = useState('');
    const [product, setProduct] = useState('');
    const [categoryList, setCategoryList] = useState([]);
    const [deleteModal, setDeleteModal] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        loadTasks();
    }, []);

    const hsnApi = (search = '', id = '') => {
        let filter = { ["or"]: [] };
        if (search !== '') {
            filter['or'].push({ hsnCode: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ description: { like: '%' + search.trim() + '%' } });
        }
        if (id !== '') {
            filter['or'].push({ id: id });
        }
        dispatch({
            type: gstActions.HSN_DETAILS_START, filter: {
                where: filter,
                order: 'hsnCode asc',
                limit: 500,
                skip: 0
            },
        });
    }

    const loadTasks = () => {
        hsnApi('');
        dispatch({
            type: gstActions.PRODUCTGST_DETAILS_START, filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: actions.CATALOGUE_DETAILS_START, filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: unitActions.UNITMESUREMENT_DETAILS_START, url: 'unit', filter: {
                order: 'id  desc'
            }
        });
    }

    const onView = (data) => {
        handleOpen();
        setView(true);
        setProductId(data.id);
        setForm({
            "productName": data?.productName,
            "description": data?.description !== null && data?.description !== '' ? data?.description : '',
            "type": data?.type,
            "productId": data?.productId,
            "catalogueId": data?.catalogue?.catalogueName,
            "categoryId": data?.category?.categoryName,
            "hsnId": data?.hsn?.hsnCode,
            "productGstId": data?.productGst?.code,
            "skuUnitId": data?.skuUnit?.name,
            "skuQuantity": parseInt(data?.skuQuantity),
            "status": data?.status,
            "mrp": data?.mrp,
        });
        setUseMrp(data?.useMrp);
    }


    const onEdit = (data) => {
        handleOpen();
        setView(false);
        setProductId(data.id);
        setForm({
            "productName": data?.productName,
            "description": data?.description !== null && data?.description !== '' ? data?.description : '',
            "type": data?.type,
            "productId": data?.productId,
            "catalogueId": data?.catalogueId,
            "categoryId": data?.categoryId,
            "hsnId": data?.hsnId,
            "skuUnitId": data?.skuUnitId,
            "salesUnitId": data?.salesUnitId,
            "skuQuantity": data?.skuQuantity,
            'productGstId': data?.productGstId,
            "status": data?.status,
            "mrp": data?.mrp,
        });
        hsnApi('', data?.hsnId);
        setUseMrp(data?.useMrp);
        changeCatalogueHandler(parseInt(data?.catalogueId));
    }

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const changeCatalogueHandler = (id, form = false) => {
        let a = categoryDetails.length > 0 ? categoryDetails.filter((el) => { return el.catalogueId === id && !el.hasSubCategories }) : [];
        setCategoryList(a);
        if (form) {
            changeHandler(id, 'catalogueId');
        }
    }

    const images = {
        beforeUpload: file => {
            const isPNG = file.type === 'image/png';
            if (!isPNG) {
                setError({
                    ...error,
                    "image": `${file.name} is not a PNG file`
                });
            }
            return isPNG || Upload.LIST_IGNORE;
        },
        onChange: info => {
        },
    };

    const changeHandler = (e, name = '') => {
        if (name !== '') {
            if (name === 'hsnId') {
                let a = hsnDetails?.length > 0 && hsnDetails.filter(function (el) { return el.id === e });
                if (a && a?.length !== 0) {
                    setForm({
                        ...form,
                        [name]: e,
                        'productGstId': a[0].productGstId
                    });
                }
            } else {
                setForm({
                    ...form,
                    [name]: e,
                });
            }
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.type === 'number' ? parseFloat(e.target.value) : e.target.value,
            });
        }
    }

    const handleOpen = () => {
        setProductId('');
        setVisible(true);
        emptyState();
        emptyStateInput();
    }

    const onDelete = (data) => {
        setDeleteModal(true);
        setProductId(data.id);
        setProduct(data.productName);
    }

    const emptyState = () => {
        setError({});
    }
    const emptyStateInput = () => {
        setForm({
            "productName": '',
            "description": '',
            "type": '',
            "productId": '',
            "catalogueId": '',
            "categoryId": '',
            "hsnId": '',
            "productGstId": '',
            "skuUnitId": '',
            "salesUnitId": '',
            "skuQuantity": '',
            "mrp": '',
            'status': "ACTIVE"
        });
    };

    const handleClose = () => {
        setVisible(false);
        emptyState();
        emptyStateInput();
    }

    const createProduct = (e) => {
        e.preventDefault();
        let emptyProductId = emptyValidation('Product ID', form.productId);
        let emptyProductName = emptyValidation('Product Name', form.productName);
        let emptyType = emptyValidation('Type', form.type);
        let emptySkuQuantity = emptyValidation('SKU Quantity', form.skuQuantity);
        let emptySkuUnitId = emptyValidation('SKU Unit', form.skuUnitId);
        let emptySalesUnitId = emptyValidation('Sales Unit', form.salesUnitId);
        let emptyMrp = emptyValidation('MRP', form.mrp);
        let sku = true;
        let price = true;
        if (form.type === 'ITEM' && !emptySkuQuantity.isValid) {
            sku = false;
        }
        if (useMrp && !emptyMrp.isValid) {
            price = false;
        }
        emptyState();
        if (emptyProductName.isValid
            && emptyProductId.isValid &&
            emptyType.isValid && sku && emptySkuUnitId.isValid && emptySalesUnitId.isValid && price) {
            if (useMrp) {
                form.useMrp = useMrp;
            }
            if (form.mrp) {
                form.mrp = parseFloat(form.mrp);
            }
            let data = Object.fromEntries(Object.entries(form).filter(([_, v]) => v != null && v !== ''));
            dispatch({
                type: productId === '' ? crudActions.CREATE_DETAILS_START : crudActions.EDIT_DETAILS_START,
                url: "universal-products",
                title: "Universal Products",
                id: productId,
                details: data
            });
            handleLoadingApi('product');
            setVisible(false);
        } else {
            setError({
                'productId': emptyProductId.errors,
                'productName': emptyProductName.errors,
                'type': emptyType.errors,
                'skuQuantity': form.type === 'ITEM' && emptySkuQuantity.errors ? emptySkuQuantity.errors : '',
                'skuUnitId': emptySkuUnitId.errors,
                'salesUnitId': emptySalesUnitId.errors,
                'mrp': useMrp && emptyMrp.errors,
            });
        }
    }

    return (
        <>
            <PrimaryTable
                heads={LinkProductsListHead}
                details={details}
                customClasses={clsx(classes.margin30t, classes.catelogueProducts)}
                component={
                    <>
                        {
                            details && details.length > 0 ? details.map((data, i) => (
                                <TableRow key={i}>
                                    <TableCell>{`${data?.productId || '---'}`}</TableCell>
                                    <TableCell><NavLink to={"#"} onClick={() => onView(data)} className={clsx(classes.color, classes.wordBreak, classes.positionRelative, classes.PaddingRight50, classes.disBlock, classes.bold)}>{data?.productName}</NavLink></TableCell>
                                    <TableCell>{`${data?.type || '---'}`}</TableCell>
                                    <TableCell>{`${data?.skuQuantity || '---'}`}</TableCell>
                                    <TableCell>{`${data?.skuUnit?.name || '---'}`}</TableCell>
                                    <TableCell>{`${data?.hsn?.hsnCode || '---'}`}</TableCell>
                                    <TableCell className={classes.textAlignRight}>{`${data?.productGst?.code || '---'}`}</TableCell>
                                    <TableCell style={{ textAlign: "right" }}>
                                        <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                            <NavLink to={"#"} onClick={() => onView(data)}>
                                                <Image src={ViewIcon} preview={false} />
                                            </NavLink>
                                            <NavLink to={"#"} onClick={() => onEdit(data)}>
                                                <Image src={EditIcon} preview={false} />
                                            </NavLink>
                                            <NavLink to={"#"} onClick={() => onDelete(data)} >
                                                <Image src={DeleteIcon} preview={false} />
                                            </NavLink>
                                        </Space>
                                    </TableCell>
                                </TableRow>
                            )) : <TableRow><TableCell style={{ textAlign: "center" }} colSpan={7}>No Products Found</TableCell></TableRow>
                        }
                    </>
                }
            />
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={`${productId ? `${view ? 'View' : 'Edit'}` : 'Add'} Product`}
                width={'690px'}
                className={clsx(classes.closeBackGround, classes.width100PCustomerandSales)}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => createProduct(e)}>
                        <div className={classes.customFormFlex}>
                            <Row type="flex" gutter={40}>
                                <Col xxl={16} xl={16} lg={16} md={8} sm={8} xs={24}>
                                    <Row type="flex">
                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                            {
                                                view ?
                                                    <>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Product ID</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.productId}</Typography>
                                                    </> :
                                                    <TextField autoComplete='one-time-code'
                                                        label={["Product ID ", <span key={"Product ID"} className={classes.colorRedRequired}> *</span>]}
                                                        variant={'standard'}
                                                        className={''}
                                                        error={error.productId ? true : false}
                                                        helperText={error.productId}
                                                        name={"productId"}
                                                        fullWidth
                                                        value={form.productId}
                                                        InputProps={{
                                                            classes: {
                                                                input: classes.textFieldColor,
                                                            }
                                                        }}
                                                        InputLabelProps={{
                                                            className: classes.textFieldLableColorCustom,
                                                        }}
                                                        onChange={(e) => changeHandler(e)}
                                                    />
                                            }
                                        </Col>
                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                            {
                                                view ?
                                                    <>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Product Name</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.productName}</Typography>
                                                    </> :
                                                    <TextField autoComplete='one-time-code'
                                                        label={["Product Name ", <span key={"Product Name"} className={classes.colorRedRequired}> *</span>]}
                                                        variant={'standard'}
                                                        className={clsx(classes.margin20t)}
                                                        error={error.productName ? true : false}
                                                        helperText={error.productName}
                                                        name={"productName"}
                                                        fullWidth
                                                        value={form.productName}
                                                        InputProps={{
                                                            classes: {
                                                                input: classes.textFieldColor,
                                                            }
                                                        }}
                                                        InputLabelProps={{
                                                            className: classes.textFieldLableColorCustom,
                                                        }}
                                                        onChange={(e) => changeHandler(e)}
                                                    />
                                            }
                                        </Col>
                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                            {
                                                view ?
                                                    <>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Description</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.description}</Typography>
                                                    </> :
                                                    <TextField autoComplete='one-time-code'
                                                        label='Description'
                                                        name={"description"}
                                                        value={form.description}
                                                        multiline
                                                        error={error.description ? true : false}
                                                        helperText={error.description}
                                                        variant="outlined"
                                                        fullWidth
                                                        className={clsx(classes.margin20t, classes.customDescription)}
                                                        rows={3}
                                                        InputProps={{
                                                            classes: {
                                                                input: classes.textFieldColor,
                                                            }
                                                        }}
                                                        InputLabelProps={{
                                                            className: classes.textFieldLableColor,
                                                        }}
                                                        onChange={(e) => changeHandler(e)}
                                                    />
                                            }
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={16} sm={16} xs={16} style={{ height: "100%" }} className={classes.feature}>
                                    <div className={clsx(classes.productImageUpload)}>
                                        <div className={classes.productImageUploadInner}>
                                            {
                                                view ?
                                                    <>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Product Image</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{'---'}</Typography>
                                                    </> :
                                                    <Upload
                                                        {...images}
                                                        // onPreview={this.handlePreview}
                                                        maxCount={1}
                                                        action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                                                        listType="picture"
                                                    >
                                                        <Typography variant={'subtitle1'} paragraph={true} className={clsx(classes.textAreaLableColorUpload, classes.fonSize13)}>Drag and Drop</Typography>
                                                        <Typography variant={'subtitle1'} paragraph={true} className={clsx(classes.textAreaLableColorUpload, classes.fonSize13)}>or</Typography>
                                                        <div className={clsx(classes.textAreaLableColorUpload, classes.fonSize13)}>
                                                            <Image
                                                                src={ImportIcon}
                                                                preview={false}
                                                                className={clsx(classes.antImage)}
                                                            /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span></div>
                                                        <Typography variant={'subtitle1'} paragraph={true} className={clsx(classes.textAreaLableColorUpload, classes.fonSize13)}>Product Image here</Typography>
                                                        <Typography variant={'subtitle1'} paragraph={true} className={clsx(classes.textAreaLableColorUpload, classes.fonSize11)}>(Image size : Not to exceed 1 MB)</Typography>
                                                    </Upload>
                                            }
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row type="flex" gutter={40} className={classes.younoteAdminProduct}>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Catalogue Name</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.catalogueId || '---'}</Typography>
                                            </> :
                                            <AutoCompleteComponent
                                                name={["Catalogue Name"]}
                                                heads={[{ 'key': 'catalogueName', 'name': 'Name' },
                                                { 'key': 'cataloguePrefix', 'name': 'Prefix' }]}
                                                details={catalogueDetails}
                                                parentValue={customObject(catalogueDetails, form.catalogueId)}
                                                position={"bottom"}
                                                customClasses={classes.margin20t}
                                                onChange={(data) => changeCatalogueHandler(data.id, true)}
                                                parentError={error.catalogueId}
                                            />
                                    }
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Category Name</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.categoryId || '---'}</Typography>
                                            </> :
                                            <AutoCompleteComponent
                                                name={["Category Name"]}
                                                heads={[{ 'key': 'categoryName', 'name': 'Name' },
                                                { 'key': 'level', 'name': 'Levels', 'suffix': "Level " }]}
                                                details={categoryList}
                                                parentValue={customObject(categoryList, form.categoryId)}
                                                position={"bottom"}
                                                customClasses={classes.margin20t}
                                                onChange={(data) => changeHandler(data.id, 'categoryId')}
                                                parentError={error.categoryId}
                                            />
                                    }
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Product Type</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.type || '---'}</Typography>
                                            </> :
                                            <AutoCompleteComponent
                                                name={["Product Type ", <span key={"Product Type"} className={classes.colorRedRequired}> *</span>]}
                                                heads={[{ 'key': 'id', 'name': 'Product Type' }]}
                                                details={[{ "id": "ITEM", "label": "Item" }, { "id": "SERVICE", "label": "Service" }]}
                                                parentValue={customObject([{ "id": "ITEM", "label": "Item" }, { "id": "SERVICE", "label": "Service" }], form.type)}
                                                onChange={(data) => changeHandler(data.id, 'type')}
                                                position={"bottom"}
                                                customClasses={classes.margin20t}
                                                parentError={error.type}
                                            />
                                    }
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>SKU Quantity</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.skuQuantity}</Typography>
                                            </> :
                                            <TextField autoComplete='one-time-code'
                                                label={form?.type === 'ITEM' ? ["SKU Quantity ", <span key={"SKU Quantity"} className={classes.colorRedRequired}> *</span>] : "SKU Quantity"}
                                                variant={'standard'}
                                                fullWidth
                                                className={clsx(classes.margin20t)}
                                                name={"skuQuantity"}
                                                value={form.skuQuantity}
                                                type={'number'}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                onWheel={(e) => e.target.blur()}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => changeHandler(e)}
                                                error={error.skuQuantity ? true : false}
                                                helperText={error.skuQuantity}
                                            />
                                    }
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>SKU Unit</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.skuUnitId || '---'}</Typography>
                                            </> :
                                            <AutoCompleteComponent
                                                name={["SKU Unit ", <span key={"SKU Unit"} className={classes.colorRedRequired}> *</span>]}
                                                heads={[{ 'key': 'name', 'name': 'Unit' },
                                                { 'key': 'description', 'name': 'Description' }]}
                                                details={unitMesurementdetails}
                                                parentValue={customObject(unitMesurementdetails, form.skuUnitId)}
                                                onChange={(data) => changeHandler(data.id, 'skuUnitId')}
                                                position={"bottom"}
                                                customClasses={classes.margin20t}
                                                parentError={error.skuUnitId}
                                            />
                                    }
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Sales Unit</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.salesUnitId || '---'}</Typography>
                                            </> :
                                            <AutoCompleteComponent
                                                name={["Sales Unit ", <span key={"Sales Unit"} className={classes.colorRedRequired}> *</span>]}
                                                heads={[{ 'key': 'name', 'name': 'Unit' },
                                                { 'key': 'description', 'name': 'Description' }]}
                                                details={unitMesurementdetails}
                                                parentValue={customObject(unitMesurementdetails, form.salesUnitId)}
                                                onChange={(data) => changeHandler(data.id, 'salesUnitId')}
                                                position={"bottom"}
                                                customClasses={classes.margin20t}
                                                parentError={error.salesUnitId}
                                            />
                                    }
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Product GST Code</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.productGstId || '---'}</Typography>
                                            </> :
                                            <AutoCompleteComponent
                                                name={["Product GST Code"]}
                                                heads={[{ 'key': 'code', 'name': 'Product GST Code' },
                                                { 'key': 'percentage', 'name': 'Percentage', 'prefix': '%' }]}
                                                details={productGstdetails}
                                                parentValue={customObject(productGstdetails, form.productGstId)}
                                                onChange={(data) => changeHandler(data.id, 'productGstId')}
                                                position={"bottom"}
                                                topPosition={true}
                                                customClasses={classes.margin20t}
                                                parentError={error.productGstId}
                                            />
                                    }
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Status</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.status}</Typography>
                                            </> :
                                            <FormControl
                                                className={clsx(classes.margin20t, classes.dropDownPointer, classes.customRadioButton)}
                                                variant={'standard'}
                                                fullWidth>
                                                <FormLabel className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Status</FormLabel>
                                                <RadioGroup
                                                    row
                                                    defaultValue="active"
                                                    aria-labelledby="demo-customized-radios"
                                                    name="status"
                                                    value={form.status}
                                                    onChange={(e) => changeHandler(e)}
                                                >
                                                    <FormControlLabel value="ACTIVE" control={<Radio
                                                        checkedIcon={<UnSelectedIcon />}
                                                        icon={<SelectedIcon />}
                                                    />} label="Active" />
                                                    <FormControlLabel value="INACTIVE" control={<Radio
                                                        checkedIcon={<UnSelectedIcon />}
                                                        icon={<SelectedIcon />}
                                                    />} label="In-Active" />
                                                </RadioGroup>
                                            </FormControl>
                                    }
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>HSN Code</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.hsnId || '---'}</Typography>
                                            </> :
                                            <AutoCompleteComponent
                                                name={["HSN Code"]}
                                                heads={[{ 'key': 'hsnCode', 'name': 'HSN Code' },
                                                { 'key': 'description', 'name': 'Description' }]}
                                                details={hsnDetails}
                                                parentValue={customObject(hsnDetails, form.hsnId)}
                                                position={"top"}
                                                searchType={(s) => hsnApi(s)}
                                                topPosition={true}
                                                customClasses={classes.margin20t}
                                                onChange={(data) => changeHandler(data.id, 'hsnId')}
                                                parentError={error.hsnId}
                                            />
                                    }
                                </Col>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Space direction="horizontal" align="center" className={clsx(classes.customLink, classes.margin15t)}>
                                        <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold)}>Prices</Typography>
                                    </Space>
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Use MRP</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                    {useMrp ? 'Yes' : 'No'}
                                                </Typography>
                                            </> :
                                            <FormControlLabel
                                                classes={{
                                                    label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink') // Pass your override css here
                                                }}
                                                control={<Switch size='small'
                                                    name={'useMrp'}
                                                    className={clsx(classes.customSwitch)}
                                                    onChange={(e) => setUseMrp(!useMrp)}
                                                    checked={useMrp}
                                                />}
                                                label="Use MRP"
                                                labelPlacement="top"
                                                className={clsx(classes.marginLeft0, classes.margin15t, classes.flexStart)}
                                            />
                                    }
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>MRP</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                    {form?.mrp || '---'}
                                                </Typography>
                                            </> :
                                            <TextField autoComplete='one-time-code'
                                                title={"Enter the maximum allowed retail price for the item"}
                                                label='MRP'
                                                variant={'standard'}
                                                fullWidth
                                                className={clsx(classes.margin20t)}
                                                name={"mrp"}
                                                value={form.mrp}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    },
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => changeHandler(e)}
                                                error={error.mrp ? true : false}
                                                helperText={error.mrp}
                                            />
                                    }
                                </Col>
                            </Row>
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            {
                                !view ?
                                    <Space direction="horizontal" align="center" size={[10, 10]}>
                                        <Button
                                            key="save"
                                            color="primary"
                                            variant="contained"
                                            type={'submit'}
                                            className={clsx(classes.modalBtn, { [classes.loading]: editLoader })}>
                                            {
                                                productId ? 'Update & Close' : 'Save & Close'
                                            }
                                        </Button>
                                    </Space> : <NavLink to={'#'} className={clsx(classes.modalBtn)} onClick={() => setView(false)}>Edit</NavLink>
                            }
                        </div>
                    </Box>
                }
            />
            <DeleteModal onClose={(v) => setDeleteModal(v)} id={productId}
                loadTasks={() => {
                    dispatch({
                        type: actions.PRODUCT_DETAILS_START,
                        filter: {
                            where: { ["and"]: [{ categoryId: categoryId }] }
                        }
                    });
                }} name={product} url={'universal-products'}
                title={'Universal Products'} visible={deleteModal} />
        </>
    )
}


export const LinkProduct = (props) => {
    const classes = customStyles();
    const { details, handleLinkedProducts } = props;
    const [selected, setSelected] = useState([]);

    const handleClick = (id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    }

    return (
        <Row className={classes.linkProductsMain}>
            <Col span={12} className={clsx(classes.borderRight, classes.heights, classes.productListTable)}>
                <div className={classes.flexWithSpaceBT}>
                    <span className={clsx(classes.addLink, classes.color, classes.bold, classes.paddingBottom20)}><span>Un-categorised Products</span>
                        <Tooltip style={{ marginLeft: 10 }}
                            classes={{ popper: classes.customToolTip }}
                            title="Select Products to Categorise" arrow placement="top" className={classes.tooltip}>
                            <IconButton>
                                <Image src={infoMarkIcon} preview={false} />
                            </IconButton>
                        </Tooltip>
                    </span>
                    {/* <Button className={clsx(classes.AddMoreBtn)} >Add to Selected Products</Button> */}
                </div>
                <LinkProductTable selecedProduct={false}
                    details={details}
                    selected={selected} handleClick={(id) => handleClick(id)}
                    onSelected={(value) => { setSelected(value); }} />
            </Col>
            <Col span={12} className={clsx(classes.padding16a, classes.heights, classes.productListTable)}>
                <div className={classes.flexWithSpaceBT}>
                    <span className={clsx(classes.addLink, classes.color, classes.bold, classes.paddingBottom20)}><span>Selected Products</span></span>
                    {/* <Button className={clsx(classes.AddMoreBtn)} >Remove from Selecterd Products</Button> */}
                </div>
                <LinkProductTable
                    selecedProduct={true}
                    details={details.length > 0 ? details.filter((el) => { return selected.find(e => e === el.id) }) : []} />
            </Col>
            <Col span={24} className={clsx(classes.linkPublish)}>
                <NavLink to="#" className={clsx(classes.modalBtn)} onClick={() => handleLinkedProducts(selected)}>Link & Publish</NavLink>
            </Col>
        </Row>
    )
}